/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdChecklist200,
  GetApiV1ClassroomdisciplineIdChecklist401,
  GetApiV1ClassroomdisciplineIdChecklist404,
  GetApiV1ClassroomdisciplineIdChecklistPathParams,
  GetApiV1ClassroomdisciplineIdChecklistQueryResponse,
} from "../../types/classPlanningCheckListController/GetApiV1ClassroomdisciplineIdChecklist.ts";
import { classPlanningChecklistItemViewModelSchema } from "../classPlanningChecklistItemViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdChecklistPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ClassroomdisciplineIdChecklistPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdChecklist200Schema = z.array(
  z.lazy(() => classPlanningChecklistItemViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdChecklist200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdChecklist401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdChecklist401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdChecklist404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdChecklist404>;

export const getApiV1ClassroomdisciplineIdChecklistQueryResponseSchema = z.lazy(
  () => getApiV1ClassroomdisciplineIdChecklist200Schema,
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdChecklistQueryResponse>;
